/**
 * F-34: a plan limit met in the middle of another flow (an upload), told by a
 * toast mounted once in the shell. The upload helpers announce; the toaster
 * (`PlanLimitToaster`) words it and offers "Ver planos" to owner and admin.
 */
export type PlanLimitAnnouncement =
  /** The video was accepted but keeps its original file (`transcodeLimit.code` of the confirm). */
  | { kind: 'transcode'; code: 'transcodeQuotaReached' | 'transcodeNotOnPlan' | 'transcodeTrialSpent' | 'streamingUnavailable' | string; message?: string | null }
  /** A new upload was refused: the plan's storage is full (409 `storageLimitReached`). */
  | { kind: 'storage'; message?: string | null }

const EVENT = 'memberfy:plan-limit'

export function announcePlanLimit(notice: PlanLimitAnnouncement): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent<PlanLimitAnnouncement>(EVENT, { detail: notice }))
}

/** Subscribes to the announcements; returns the unsubscribe. */
export function onPlanLimit(listener: (notice: PlanLimitAnnouncement) => void): () => void {
  const handler = (e: Event) => listener((e as CustomEvent<PlanLimitAnnouncement>).detail)
  window.addEventListener(EVENT, handler)
  return () => window.removeEventListener(EVENT, handler)
}

/** A 409 from `upload-url(s)` whose field is `size` is the storage limit (the only 409 there). */
export const isStorageLimitError = (error: unknown): boolean => {
  const e = error as { response?: { status?: number; data?: { errors?: Array<{ param?: string }> } } } | null
  return e?.response?.status === 409 && e.response.data?.errors?.[0]?.param === 'size'
}
